import styled from 'styled-components';

export const FadeInContainer = styled.div<{ $anime?: string }>`
  /* visibility: hidden; */
  animation: fadein ${props => props.$anime || '.3s'};
  animation-fill-mode: initial;
  position: relative;
  @keyframes fadein {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;
